import { Serializable } from '../../../core/models/serializable';
export class AnnouncementsTotalPerCustomerListItemHeadModel
  implements Serializable<AnnouncementsTotalPerCustomerListItemHeadModel>
{
  fromObject(obj: any): AnnouncementsTotalPerCustomerListItemHeadModel {
    Object.assign(this, obj);
    return this;
  }

  toObject() {
    throw new Error('Method not implemented.');
  }

  public customerId: number;
  public customer: string;
  public total: number;
}
